import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../../core/service/v2/service/action/abstractAction.service";
import {Payload} from "../../../../../core/service/payload/payload";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
@Injectable()
export class FormDefinitionGetRulesService
    extends AbstractActionService<FormDefinitionGetRulesPayload, FormDefinitionGetRulesResponse[]> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('FormDefinitionForm', 'get-rules', customizeHttpUrlGenerator, httpClient);
    }
}


export class FormDefinitionGetRulesPayload implements Payload {
    formDefinitionId: number;
    versionId: number;
}

export class FormDefinitionGetRulesResponse {
    name: string;
    srcFields: FormDefinitionGetRulesResponseSrcField[] = [];
}

export class FormDefinitionGetRulesResponseSrcField {
    fieldId: number;
    required = false;
}


